module.exports = __webpack_public_path__ + "/login_ui/img/arrow-abd61038249626b14cb34d567718da14.svg";